//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



export default{
  components: {
    
  },
  data() {
     return{
        tag:'yawen',
        showMenus: false,
        is_show_footer: true
      }
  },
   /*mounted(){
   
    WxFooter
    import WxFooter from './components/Footer'
    let route_path = this.$route.path;
    console.log('this.is_show_footer::'+this.is_show_footer);

    if(route_path == '/PaymentCenter' || route_path == '/FixMy' || route_path == '/ComplainMy' || route_path == '/LetPassMy'){
        this.is_show_footer = false;
    }
  }*/
}




// WEBPACK FOOTER //
// ./src/App.vue